import { prop } from '@ipfabric/utils/fp/prop';
import { useGlobalStateContextSelectors } from 'components/GlobalState/GlobalStateModel';
import type Immutable from 'immutable';
import {
  makeSelectAllSnapshots,
  makeSelectCurrentSnapshot,
} from 'pages/SnapshotManagement/selectors';
import type { ImmutableSnapshot } from 'pages/SnapshotManagement/snapshotManagementTypes';
import { type FC, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';

interface Selector {
  snapshot: ImmutableSnapshot;
  snapshots: Immutable.List<ImmutableSnapshot>;
}

const homePageSelector = createStructuredSelector({
  snapshot: makeSelectCurrentSnapshot(),
  snapshots: makeSelectAllSnapshots(),
});

export const HomePage: FC = () => {
  const navigate = useNavigate();
  const { snapshot, snapshots } = useSelector<unknown, Selector>(
    homePageSelector,
  );

  const ctxProps = useGlobalStateContextSelectors({
    scope: prop('auth', 'scope'),
  });

  const hasSettingsPermissions = ctxProps.scope.includes('settings');
  const hasWritePermissions = ctxProps.scope.includes('write');

  // biome-ignore lint/correctness/useExhaustiveDependencies: designed to run only on first load
  useEffect(() => {
    const status = snapshot?.get('status') ?? null;
    if (
      (status && ['run', 'finishing'].includes(status)) ||
      !hasSettingsPermissions
    ) {
      if (hasWritePermissions) {
        navigate('/snapshot-management', { replace: true });
      } else {
        navigate('/dashboard/overview', { replace: true });
      }
    } else if (snapshots.size) {
      navigate('/dashboard/overview', { replace: true });
    } else {
      navigate('/wizard/1', { replace: true });
    }
  }, []);

  return null;
};
